import React  from 'react';
import { getCrouselDataInFormat } from '../../config/utils';
import * as S from './CabHourlyCarouselItemStyle';

const CabHourlyCarouselItemUI = ({item, isSelected, onSelect}) => {
  const { package_id, name, time, distance, min_fare } = getCrouselDataInFormat(item)
  return (
    <S.CarouselItem package_id={package_id} selected={isSelected} onClick={() => onSelect(package_id || name, time)}>
      <p className={package_id ? 'title' : ''}>
        <span className='rubik'>{time} {package_id ? '' : 'hr'}</span>{package_id ? distance : `(${distance} km)`}
      </p>
      {
        min_fare && <div className='priceText'>{min_fare}</div>
      }
    </S.CarouselItem>
  );
};

export default CabHourlyCarouselItemUI;
